var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.14227H17.6766C16.9586 7.14227 16.3766 6.56024 16.3766 5.84227V2M21 7.14227L16.3766 2M21 7.14227V18.6387C21 18.7635 21 18.8843 21 19.0011C21 20.6579 19.6569 22 18 22H6C4.34315 22 3 20.6579 3 19.0011C3 18.8843 3 18.7635 3 18.6387L3.04297 6.4818C3.04297 5.96233 3.04297 5.4635 3.04297 4.99953C3.04297 3.34268 4.38612 2 6.04297 2H16.3766M6.37643 12.2019H17.6373M6.37643 14.8661H12.6398M17.6373 18.0894V18.0894C17.2445 18.4708 16.5924 18.3474 16.3662 17.8488L16.3378 17.7864C16.1853 17.4503 15.7044 17.4607 15.5666 17.8031L15.2329 18.6319C15.1174 18.9188 14.7343 18.9725 14.5444 18.7284L14.2459 18.3448C13.8648 17.855 13.1132 17.8918 12.7817 18.4165V18.4165M7.4194 5.44372H9.52417C10.0765 5.44372 10.5242 5.89143 10.5242 6.44372V8.57282C10.5242 9.1251 10.0765 9.57282 9.52417 9.57282H7.4194C6.86712 9.57282 6.4194 9.1251 6.4194 8.57282V6.44372C6.4194 5.89143 6.86712 5.44372 7.4194 5.44372Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.4b66f84fc0186720a9693a49bc71c22e.svg";
export { ForwardRef as ReactComponent };